import { gql } from "@apollo/client";

export const genericFileUploadSignatureMutation = gql `
mutation($input: DocumentInput!){
  genericFileUploadSignatureUrl(input: $input) {
    message
    response
  }
}
`;